import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default  {
  namespaced: true,
  state: {
    menuItems:[],
    signedIn:false,
    curUser:null,
    webUser:null,

  },
  actions,
  mutations,
  getters
}
